import { Text, Icon } from '@shopify/polaris';
import type { IconProps } from '@shopify/polaris';

type IconSource = IconProps['source'];

interface HelpCategoryCardProps {
  id: string;
  label: string;
  icon: IconSource;
  color: string;
  description: string;
  onClick: (categoryId: string) => void;
}

export function HelpCategoryCard({
  id,
  label,
  icon,
  color,
  description,
  onClick,
}: HelpCategoryCardProps) {
  return (
    <button
      onClick={() => onClick(id)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '20px',
        backgroundColor: 'white',
        border: '1px solid #e1e3e5',
        borderRadius: '12px',
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'all 0.2s ease',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        width: '100%',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)';
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.borderColor = color;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.borderColor = '#e1e3e5';
      }}
    >
      <div
        style={{
          width: '48px',
          height: '48px',
          borderRadius: '12px',
          backgroundColor: `${color}15`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '16px',
          color: color,
        }}
      >
        <div style={{ transform: 'scale(1.3)' }}>
          <Icon source={icon} />
        </div>
      </div>
      <Text as="span" variant="headingSm" fontWeight="semibold">
        {label}
      </Text>
      <div style={{ marginTop: '8px' }}>
        <Text as="span" variant="bodySm" tone="subdued">
          {description}
        </Text>
      </div>
    </button>
  );
}

interface HelpCategoryCardsProps {
  categories: Array<{
    id: string;
    label: string;
    icon: IconSource;
    color: string;
    description: string;
  }>;
  onCategoryClick: (categoryId: string) => void;
}

export function HelpCategoryCards({ categories, onCategoryClick }: HelpCategoryCardsProps) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        marginBottom: '32px',
      }}
    >
      {categories.slice(0, 6).map((category) => (
        <HelpCategoryCard
          key={category.id}
          {...category}
          onClick={onCategoryClick}
        />
      ))}
    </div>
  );
}
